import type { TenantCreate, TenantCreated, TenantUpdate, TenantView } from '@messe/shared'
import { apiRequest } from './api.js'

export type { TenantView, TenantCreated }

export function listTenants(): Promise<TenantView[]> {
  return apiRequest<TenantView[]>('/tenants')
}

export function createTenant(input: TenantCreate): Promise<TenantCreated> {
  return apiRequest<TenantCreated>('/tenants', { method: 'POST', body: input })
}

export function updateTenant(id: string, changes: TenantUpdate): Promise<TenantView> {
  return apiRequest<TenantView>(`/tenants/${id}`, { method: 'PATCH', body: changes })
}
